import React, { useEffect, useState } from 'react';
import { message, Modal } from 'antd';
import axios from '../../util/Api';

const BroadcastConsumer = ({ onClose }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [broadcast, setBroadcast] = useState({});
  useEffect(() => {
    getBroadcast();
  }, []);

  const getBroadcast = () => {
    setLoading(true);
    const url = `/broadcast/detail`;
    axios.get(url).then(resp => {
      setBroadcast(resp.data);
      setOpen(resp.data.is_active);
      setLoading(false);
    }).catch(err => {
      message.error("Broadcast message gagal diperbarui");
    });
  }

  const handleOk = () => {
    setOpen(false);
    if(onClose) onClose(true);
  }

  return (
    <>
      <Modal width={700} style={{ top: 20 }} title="Broadcast Message" visible={open} onCancel={handleOk} onOk={handleOk} okText="Tutup">
        {loading ? "Sedang memuat..." : <span dangerouslySetInnerHTML={{__html: broadcast.content}}></span>}
      </Modal>
    </>
  );
}

export default BroadcastConsumer;